import axios from 'axios'
import { environment } from '@/data/environment/'

export default {
  namespaced: true,
  state: {
    error: null,
    loadingFileProcess: false,
    loadingWsProcess: false,
    loadingTestConnection: false,
    loadingWsList: false,
    loadingWsStatus: false,
    fileProcessStatus: null,
    fileProcessMessage: '',
    fileProcessResponse: null,
    wsProcessStatus: null,
    wsProcessMessage: '',
    wsProcessResponse: null,
    testConnectionStatus: null,
    testConnectionMessage: '',
    bridgeCredentials: null,
    wsList: [],
    wsListError: '',
  },
  mutations: {
    setLoadingFileProcess(state, value) {
      state.loadingFileProcess = value
    },
    setLoadingWsProcess(state, value) {
      state.loadingWsProcess = value
    },
    setLoadingTestConnection(state, value) {
      state.loadingTestConnection = value
    },
    setFileProcessStatus(state, value) {
      state.fileProcessStatus = value
    },
    setFileProcessMessage(state, value) {
      state.fileProcessMessage = value
    },
    setFileProcessResponse(state, value) {
      state.fileProcessResponse = value
    },
    setWsProcessStatus(state, value) {
      state.wsProcessStatus = value
    },
    setWsProcessMessage(state, value) {
      state.wsProcessMessage = value
    },
    setWsProcessResponse(state, value) {
      state.wsProcessResponse = value
    },
    setTestConnectionStatus(state, value) {
      state.testConnectionStatus = value
    },
    setTestConnectionMessage(state, value) {
      state.testConnectionMessage = value
    },
    setBridgeCredentials(state, value) {
      state.bridgeCredentials = value
    },
    setLoadingWsList(state, value) {
      state.loadingWsList = value
    },
    setLoadingWsStatus(state, value) {
      state.loadingWsStatus = value
    },
    setWsList(state, value) {
      state.wsList = value
    },
    setWsListError(state, value) {
      state.wsListError = value
    },
  },
  actions: {
    processAtsFile({ commit }, payload) {
      commit('setLoadingFileProcess', true)
      commit('setFileProcessStatus', null)
      commit('setFileProcessMessage', '')
      commit('setFileProcessResponse', null)

      const endpoint = '/processAtsFile'
      const url = environment.HIOPOSWEBSERVICES + endpoint

      const user = JSON.parse(atob(localStorage.getItem('uid')))

      const formData = new FormData()
      formData.append('file', payload.file)
      formData.append('fechaInicio', payload.fechaInicio)
      formData.append('fechaFin', payload.fechaFin)
      formData.append('periodoInformado', payload.periodoInformado)
      formData.append('tipoPeriodicidad', payload.tipoPeriodicidad)
      formData.append('idCompania', payload.idCompania || user.idcompania)
      formData.append('userId', user.userId)
      formData.append('userName', user.nameUser)

      return axios
        .create()
        .post(url, formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
        })
        .then(response => {
          commit('setLoadingFileProcess', false)
          if (!response.data.respuesta.Error) {
            commit('setFileProcessStatus', true)
            commit('setFileProcessMessage', response.data.respuesta.Mensaje || 'Archivo procesado exitosamente')
            commit('setFileProcessResponse', response.data.respuesta.Datos)
            return response.data.respuesta.Datos
          }
          commit('setFileProcessStatus', false)
          commit('setFileProcessMessage', response.data.respuesta.Mensaje || 'Error al procesar el archivo')
          throw new Error(response.data.respuesta.Mensaje)
        })
        .catch(error => {
          commit('setLoadingFileProcess', false)
          if (!error.message.includes('Error al procesar')) {
            commit('setFileProcessStatus', false)
            commit('setFileProcessMessage', 'Error al procesar el archivo: ' + error.message)
          }
          throw error
        })
    },

    getBridgeCredentials({ commit }, payload) {
      const user = JSON.parse(atob(localStorage.getItem('uid')))
      const idCompania = payload.idCompania || user.idcompania

      const endpoint = '/getBridgeCredentials?IdCompania=' + idCompania
      const url = environment.HIOPOSWEBSERVICES + endpoint

      return axios
        .create()
        .get(url)
        .then(response => {
          if (!response.data.respuesta.Error) {
            commit('setBridgeCredentials', response.data.respuesta.Datos)
            return response.data.respuesta.Datos
          }
          commit('setBridgeCredentials', null)
          return null
        })
        .catch(error => {
          console.error('Error al obtener credenciales Bridge:', error.message)
          commit('setBridgeCredentials', null)
          return null
        })
    },

    testBridgeConnection({ commit }, payload) {
      commit('setLoadingTestConnection', true)
      commit('setTestConnectionStatus', null)
      commit('setTestConnectionMessage', '')

      const endpoint = '/testBridgeConnection'
      const url = environment.HIOPOSWEBSERVICES + endpoint

      const user = JSON.parse(atob(localStorage.getItem('uid')))

      const body = {
        idCompania: payload.idCompania || user.idcompania,
        bridgeUser: payload.bridgeUser,
        bridgePassword: payload.bridgePassword,
        userId: user.userId,
        userName: user.nameUser,
      }

      return axios
        .create()
        .post(url, body)
        .then(response => {
          commit('setLoadingTestConnection', false)
          if (!response.data.respuesta.Error) {
            commit('setTestConnectionStatus', true)
            commit('setTestConnectionMessage', response.data.respuesta.Mensaje || 'Conexión exitosa')
            return true
          }
          commit('setTestConnectionStatus', false)
          commit('setTestConnectionMessage', response.data.respuesta.Mensaje || 'Error en la conexión')
          return false
        })
        .catch(error => {
          commit('setLoadingTestConnection', false)
          commit('setTestConnectionStatus', false)
          commit('setTestConnectionMessage', 'Error al probar la conexión: ' + error.message)
          return false
        })
    },

    processAtsWebService({ commit }, payload) {
      commit('setLoadingWsProcess', true)
      commit('setWsProcessStatus', null)
      commit('setWsProcessMessage', '')
      commit('setWsProcessResponse', null)

      const endpoint = '/processAtsWebService'
      const url = environment.HIOPOSWEBSERVICES + endpoint

      const user = JSON.parse(atob(localStorage.getItem('uid')))

      const body = {
        fechaInicio: payload.fechaInicio,
        fechaFin: payload.fechaFin,
        periodoInformado: payload.periodoInformado,
        tipoPeriodicidad: payload.tipoPeriodicidad,
        idCompania: payload.idCompania || user.idcompania,
        userId: user.userId,
        userName: user.nameUser,
      }

      return axios
        .create()
        .post(url, body)
        .then(response => {
          commit('setLoadingWsProcess', false)
          if (!response.data.respuesta.Error) {
            const datos = response.data.respuesta.Datos
            const result = Array.isArray(datos) ? datos[0] : datos
            commit('setWsProcessStatus', true)
            commit('setWsProcessMessage', response.data.respuesta.Mensaje || 'Solicitud de exportación registrada')
            commit('setWsProcessResponse', result)
            return result
          }
          commit('setWsProcessStatus', false)
          commit('setWsProcessMessage', response.data.respuesta.Mensaje || 'Error al solicitar la exportación')
          throw new Error(response.data.respuesta.Mensaje)
        })
        .catch(error => {
          commit('setLoadingWsProcess', false)
          if (!error.message.includes('Error al solicitar')) {
            commit('setWsProcessStatus', false)
            commit('setWsProcessMessage', 'Error al solicitar la exportación: ' + error.message)
          }
          throw error
        })
    },

    getAtsWebServiceStatus({ commit }, payload) {
      commit('setLoadingWsStatus', true)

      const endpoint = '/processAtsWebService/status/' + payload.trackingId
      const url = environment.HIOPOSWEBSERVICES + endpoint

      return axios
        .create()
        .get(url)
        .then(response => {
          commit('setLoadingWsStatus', false)
          if (!response.data.respuesta.Error) {
            const datos = response.data.respuesta.Datos
            return Array.isArray(datos) ? datos[0] : datos
          }
          throw new Error(response.data.respuesta.Mensaje || 'Error al consultar estado')
        })
        .catch(error => {
          commit('setLoadingWsStatus', false)
          throw error
        })
    },

    getAtsWebServiceList({ commit }, payload) {
      commit('setLoadingWsList', true)
      commit('setWsListError', '')

      const user = JSON.parse(atob(localStorage.getItem('uid')))
      const idCompania = (payload && payload.idCompania) || user.idcompania

      const endpoint = '/processAtsWebService/list/' + idCompania
      const url = environment.HIOPOSWEBSERVICES + endpoint

      return axios
        .create()
        .get(url)
        .then(response => {
          commit('setLoadingWsList', false)
          if (!response.data.respuesta.Error) {
            const datos = response.data.respuesta.Datos
            const list = Array.isArray(datos) ? datos : []
            commit('setWsList', list)
            return list
          }
          commit('setWsListError', response.data.respuesta.Mensaje || 'Error al consultar el listado')
          return []
        })
        .catch(error => {
          commit('setLoadingWsList', false)
          commit('setWsListError', 'Error al consultar el listado: ' + error.message)
          return []
        })
    },

    resetFileProcess({ commit }) {
      commit('setFileProcessStatus', null)
      commit('setFileProcessMessage', '')
      commit('setFileProcessResponse', null)
    },

    resetWsProcess({ commit }) {
      commit('setWsProcessStatus', null)
      commit('setWsProcessMessage', '')
      commit('setWsProcessResponse', null)
    },

    resetWsList({ commit }) {
      commit('setWsList', [])
      commit('setWsListError', '')
    },

    resetTestConnection({ commit }) {
      commit('setTestConnectionStatus', null)
      commit('setTestConnectionMessage', '')
    },
  },
}
